<template>
  <div>
    <search-form @hotels="showHotels" :checkin-data="checkin" :checkout-data="checkout" :destination="destination" :city-name="cityName" :selected-hotel-data="selectedHotel"></search-form>
    <search-results v-if="showResults" :type="type" :content="hotels" :selectedHotel="selectedHotel" :city-name="city" :checkin="checkin" :checkout="checkout" :currency="currency"></search-results>
  </div>
</template>

<script>
import SearchForm from "./SearchForm.vue";
import SearchResults from "./SearchResults.vue";
export default {
  name: "Search",
  components: { SearchResults, SearchForm },
  props: {
    hotelsData: Array,
    typeData: String,
    checkinData: String,
    checkoutData: String,
    selectedHotelData: Object,
    cityName: String,
  },
  data() {
    return {
      hotels: [],
      checkin: null,
      checkout: null,
      showResults: false,
      type: null,
      destination: null,
      selectedHotel: null,
      city: null,
      currency: localStorage.getItem('currency') ?? 'USD',
    }
  },
  mounted() {
    if(this.typeData) this.type = this.typeData;
    if(this.selectedHotelData) this.selectedHotel = this.selectedHotelData;
    this.city = this.cityName;
    if(this.hotelsData.length > 0) {
      this.destination = this.hotelsData[0].city;
      this.checkin = this.checkinData;
      this.checkout = this.checkoutData;
      this.hotels = this.hotelsData;
      this.showResults = true;
    }
  },
  methods: {
    showHotels(data) {
      const { hotels, selectedHotel, checkin, checkout, currency, city } = data;
      this.city = city;
      this.hotels = hotels;
      if(checkin && checkout) {
        this.checkin = checkin;
        this.checkout = checkout;
      }
      if(currency) this.currency = currency;
      this.selectedHotel = selectedHotel;
      this.type = 'hotels';
      this.showResults = hotels.length > 0;
    }
  }
}
</script>

<style scoped>

</style>
